var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-table" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.orderDetailTableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_number", label: "子订单号", width: "140" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ruigu_code", label: "锐锢编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "self_code", label: "三方商品编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "商品名", width: "280" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "spec", label: "规格" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "unit", label: "单位" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "total_price", label: "订单金额" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "price", label: "单价" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "amount", label: "订购数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "send_amount", label: "实发数量" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "mo_statusName", label: "状态" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "refuse_msg", label: "申请备注", width: "160" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.shopIds.indexOf(_vm.shop_id) > -1
                      ? _c(
                          "div",
                          [
                            _vm.isJgj
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        scope.row.mo_status !== "3" ||
                                        scope.row.status !== "1" ||
                                        !scope.row.is_enable_refuse
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showDialog(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("申请拒单")]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        scope.row.mo_status !== "2" ||
                                        scope.row.status !== "1" ||
                                        !scope.row.is_enable_refuse
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showDialog(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("申请拒单")]
                                )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "refuse-dialog",
          attrs: {
            visible: _vm.orderRefuseVisible,
            "append-to-body": true,
            title: _vm.dialogTitle,
            width: "430px",
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderRefuseVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c("div", {
                staticClass: "title",
                domProps: { innerHTML: _vm._s(_vm.dialogTitle) }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "refuseForm",
              staticClass: "refuse-form",
              attrs: {
                model: _vm.refuseForm,
                rules: _vm.rules,
                "label-width": "76px",
                inline: true
              }
            },
            [
              _c("div", { staticClass: "fs-12" }, [
                _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                _vm._v(
                  "注意：拒单申请提交后需依据客服沟通结果来确认是否需要继续履约\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "来源单号", prop: "orderNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.refuseForm.orderNo,
                      callback: function($$v) {
                        _vm.$set(_vm.refuseForm, "orderNo", $$v)
                      },
                      expression: "refuseForm.orderNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "拒单原因", prop: "code" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        placeholder: "请选择拒单原因",
                        prop: "code"
                      },
                      model: {
                        value: _vm.refuseForm.code,
                        callback: function($$v) {
                          _vm.$set(_vm.refuseForm, "code", $$v)
                        },
                        expression: "refuseForm.code"
                      }
                    },
                    _vm._l(_vm.refuseMap, function(item, index) {
                      return _c("el-option", {
                        key: index + 1,
                        attrs: { label: item, value: index + 1 }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.refuseForm.code === 5
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "m-t-10",
                      attrs: { label: "原因描述", prop: "msg" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "margin-top": "8px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入...",
                          prop: "msg",
                          maxlength: "30",
                          "show-word-limit": "",
                          autosize: { minRows: 2, maxRows: 4 }
                        },
                        model: {
                          value: _vm.refuseForm.msg,
                          callback: function($$v) {
                            _vm.$set(_vm.refuseForm, "msg", $$v)
                          },
                          expression: "refuseForm.msg"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("refuseForm")
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("refuseForm")
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd89ac1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd89ac1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigorder/order-detail-table.vue
// module id = null
// module chunks = 